<template>
    <FontAwesomeLayers v-bind="$attrs">
        <slot></slot>
    </FontAwesomeLayers>
</template>

<script>
    import { FontAwesomeLayers } from '@fortawesome/vue-fontawesome';

    export default {
        /**
         * Determine how unrecognized component properties should be handled by the Vue compiler.
         *
         * @link https://vuejs.org/v2/api/#inheritAttrs
         *
         * @type {Boolean}
         */
        inheritAttrs: false,

        /**
         * Declaratively register required components.
         *
         * @link https://vuejs.org/v2/guide/components.html#Local-Registration
         */
        components: {
            FontAwesomeLayers,
        },
    };
</script>
